var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0F6FA"
    },
    d: "M256,0c-5.751,0-11.39,0.482-16.879,1.402l80.071,70.527l32.505-3.863C337.95,28.446,300.3,0,256,0z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0F6FA"
    },
    d: "M376.967,67.516c-5.813,0-11.444,0.757-16.824,2.143l-16.934,132.89h33.758 c37.288,0,67.517-30.228,67.517-67.516S414.255,67.516,376.967,67.516z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0FBFD"
    },
    d: "M410.725,135.033c0-31.44-21.49-57.859-50.582-65.374c-2.452,0.631-4.856,1.381-7.192,2.27 c-0.393-1.299-0.81-2.587-1.254-3.863c-2.783-0.349-5.612-0.549-8.489-0.549c-8.462,0-16.553,1.571-24.017,4.413 c-11-36.387-41.916-64.125-80.071-70.527c-38.155,6.403-69.073,34.141-80.071,70.527c-7.464-2.842-15.555-4.413-24.017-4.413 c-37.288,0-67.516,30.228-67.516,67.516s30.228,67.516,67.516,67.516h208.176C380.497,202.549,410.725,172.321,410.725,135.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7D9DD"
    },
    d: "M256,115.341l-11.253,16.879L256,149.099c29.52,0,53.451,23.931,53.451,53.451s0,120.967,0,120.967 h33.758c0,0,0-72.803,0-120.967S304.164,115.341,256,115.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7E7EB"
    },
    d: "M168.791,202.549c0,48.164,0,120.967,0,120.967h33.758c0,0,0-91.448,0-120.967 s23.93-53.451,53.451-53.451v-33.758C207.836,115.341,168.791,154.385,168.791,202.549z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#88ACB5"
    },
    points: "343.209,289.758 309.451,400.879 343.209,512 376.967,512 376.967,289.758 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.033,
    y: 289.758,
    style: {
      fill: "#A7CBCF"
    },
    width: 208.176,
    height: 222.242
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2F5E88"
    },
    cx: 256,
    cy: 384,
    r: 16.879
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F5E88"
    },
    d: "M247.56,389.626v45.011c0,4.662,3.779,8.44,8.44,8.44c4.661,0,8.44-3.778,8.44-8.44v-45.011H247.56z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88ACB5"
    },
    cx: 210.989,
    cy: 469.802,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#88ACB5"
    },
    cx: 177.231,
    cy: 436.044,
    r: 8.44
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.8aac7c4be35014dd613a658cded22551.svg";
export { ForwardRef as ReactComponent };